<template>
	<div name="mainpopup">
		<div 
			class="wrapper" 
			v-if="view"
			@mouseenter="pauseAutoPlay"
			@mouseleave="resumeAutoPlay"
		>
		<!-- 롤링팝업 -->
			<!-- <div class="popup-body">
				<div class="img-wrap">
					<a href="https://bit.ly/QR_BC19">
						<img class="img" src="../../assets/popup/img_popup_2025_1.png" alt="" v-show="currentIndex === 0"/>
					</a>
					<div class="sr-only">
						<h2>설 연휴 배송 안내</h2>
						<p>설 연휴 CGM+소모품재료 출고 시점 안내</p>
						<ul>
							<li>
								<dl>
									<dt>접수 마감</dt>
									<dd>1/24(금) 오후 12시까지</dd>
								</dl>
							</li>
							<li>
								<dl>
									<dt>배송 재개</dt>
									<dd>1/31(금) 순차 출고</dd>
								</dl>
							</li>
						</ul>
						<p>다가오는 설 연휴, 의료기관과 택배사가 함께 휴무에 들어갑니다. 건강하고 즐거운 연휴 되시길 바랍니다</p>
						<span>솔닥컨시어지 드림</span>
					</div>
				</div>
				<div class="img-wrap" v-show="currentIndex === 1">
					<a href="https://bit.ly/QR_BC19">
						<img class="img" src="../../assets/popup/img_popup_2025_2.png" alt="" />
					</a>
					<div class="sr-only">
						<h2>신년 감사 이벤트</h2>
						<ul>
							<li>
								<dl>
									<dt>EVENT 01</dt>
									<dd>솔닥 컨시어지 후기 작성시 3만원 상당 상품권 또는 네이버페이 증정</dd>
								</dl>
							</li>
							<li>
								<dl>
									<dt>EVENT 02</dt>
									<dd>연속혈당측정기 전극(CGM) 구매시 10만원 상당 상품권 또는 네이버페이 증정 </dd>
								</dl>
							</li>
						</ul>
					</div>
				</div>				
			</div> -->

			<!-- 단일팝업 -->
			<div class="popup-body">
				<div class="img-wrap">
					<a href="https://bit.ly/soldoc_home">
						<img class="img" src="../../assets/popup/img_popup_2025_3.jpg" alt="상세 내용 하단 참고"/>
					</a>
					<div class="sr-only">
						<h2>신년맞이 고객 감사 이벤트</h2>
						<ul>
							<li>
								<dl>
									<dt>event01</dt>
									<dd>솔닥 컨시어지 후기 작성시 3만원 상당 상품권 또는 네이버페이 증정</dd>
								</dl>
							</li>
							<li>
								<dl>
									<dt>event02</dt>
									<dd>연속혈당측정기 전극(CGM) 구매시 10만원 상당 상품권 또는 네이버페이 증정</dd>
								</dl>
							</li>
						</ul>
						<span>2025.02.01(토)-2025.02.28(금)</span>
					</div>
				</div>		
			</div>  

			<!-- 롤링 버튼 -->
			<!-- <div class="btn-area">
				<div class="btn-wrap">
					<button 
						type="button" 
						:class="['btn-tab', currentIndex === 0 ? 'selected' : '']"
						@click="selectTab(0)"
					>
						<span>NOTICE</span>
						<p>설 연휴 배송 안내</p>
					</button>
				</div>
				<div class="btn-wrap">
					<button 
						type="button" 
						:class="['btn-tab', currentIndex === 1 ? 'selected' : '']"
						@click="selectTab(1)"
					>
						<span>EVENT</span>
						<p>신년 감사 이벤트</p>
					</button>
				</div>
			</div> -->
			<div class="bottom">
				<span class="checkbox-wrapper">
					<input id="today" type="checkbox" v-model="doNotShowToday">
					<label for="today" class="checkbox-text">오늘 하루 보지 않기</label>
				</span>
				<button type="button" :class="['button', pageButtonClass]" @click="close"><i class="ico-close"></i></button>
			</div>
		</div>
	</div>
</template>

<script>
import cookies from "@/utilities/cookie.js";

export default {
	name: "mainpopup",
	data() {
		return {
			view: false,
			doNotShowToday: false,
			currentIndex: 0,
			autoPlayInterval: null,
			isHovered: false
		};
	},
	props: {
		pageButtonClass: {
			type: String,
			default: ""
		}
	},
	mounted() {
		this.view = cookies.getCookie("today") !== "false";
		this.startAutoPlay();
	},
	beforeDestroy() {
		this.stopAutoPlay();
	},
	methods: {
		selectTab(index) {
			this.currentIndex = index;
			// 탭 클릭시 자동 재생 초기화
			this.stopAutoPlay();
			if (!this.isHovered) {
				this.startAutoPlay();
			}
		},
		startAutoPlay() {
			if (!this.autoPlayInterval && !this.isHovered) {
				this.autoPlayInterval = setInterval(() => {
					this.currentIndex = (this.currentIndex + 1) % 2;
				}, 5000);
			}
		},
		stopAutoPlay() {
			if (this.autoPlayInterval) {
				clearInterval(this.autoPlayInterval);
				this.autoPlayInterval = null;
			}
		},
		pauseAutoPlay() {
			this.isHovered = true;
			this.stopAutoPlay();
		},
		resumeAutoPlay() {
			this.isHovered = false;
			this.startAutoPlay();
		},
		close() {
			if (this.doNotShowToday) {
				cookies.setCookie("today", false);
			}
			this.view = false;
			this.stopAutoPlay();
		},
		goSoldocGuide() {
			window.open(
				"https://www.mohw.go.kr/react/al/sal0101vw.jsp?PAR_MENU_ID=04&MENU_ID=040101&page=1&CONT_SEQ=376488",
				"_blank"
			);
		}
	}
};
</script>


<style scoped>
p {
	margin-bottom: 0;
}
.wrapper {
	position: relative;
	position: fixed;
	top: 200px;
	left: 300px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* width: 366px; */
	width: 330px;
	z-index: 999;
}
.popup-body {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: auto;
	/* height: 418px; */
	/* padding: 34px 20px; */
	background: #f8f9ff;
}
.img {
	width: 100%;
}
.ico-close {
	display: inline-block;
	width: 16px;
	height: 16px;
	margin-top: 4px;
	background: url(../../assets/popup/ico_close_white.png) no-repeat center/cover;
}
.popup-body .logo {
	width: 53px;
	text-align: center;
}
.popup-body .title {
	margin: 19px 0 15px;
	font-family: "Pretendard";
	font-size: 33px;
	font-weight: 600;
	color: #1a1a1a;
	text-align: center;
}
.popup-body .title strong {
	display: block;
	font-weight: 600;
	color: #1f70ff;
}
.popup-body .date {
	font-size: 19px;
	font-weight: 600;
	text-align: center;
	color: #1a1a1a;
}
.popup-body .list {
	width: 100%;
	margin: 24px 0 35px;
	padding: 0;
	font-family: "Pretendard";
	font-size: 17px;
	font-weight: 400;
	line-height: 26px;
	color: #1a1a1a;
	list-style-type: none;
}
.popup-body .list-box li {
	position: relative;
	width: 100%;
	height: 79px;
	padding: 13px 30px 14px 48px;
	border-radius: 8px;
	background: #e6edff;
}
.popup-body .list-box li strong {
	font-weight: 600;
}
.popup-body .list-box li + li {
	margin-top: 15px;
}
.popup-body .list-box li:before {
	position: absolute;
	top: 17px;
	left: 17px;
	width: 20px;
	height: 20px;
	background: url(../../assets/popup/ico_bullet_blue.png);
	content: "";
}
.popup-body .list-box .bg-red {
	background: #f6dfd9;
}
.popup-body .list-box .bg-red:before {
	background: url(../../assets/popup/ico_bullet_red.png);
}
.wrapper .btn-area {
	width: 100%;
}
.wrapper .btn-area .btn-text {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 66px;
	background: #1a1a1a;
	font-size: 18px;
	font-weight: 400;
	line-height: 26px;
	color: #fff;
}
.wrapper .btn-text strong {
	display: inline;
	padding-left: 5px;
	font-weight: 700;
}
.wrapper .btn-text:hover {
	text-decoration: none;
}

.wrapper .bottom {
	height: 32px;
	width: 100%;
	background: #1a1a1a;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0px 11px 0px 11px;
}

.btn-wrapper {
	position: absolute;
	left: 50%;
	bottom: 96px;
	transform: translateX(-50%);
	display: block;
	width: 100%;
	text-align: center;
}

.text-btn:after {
	position: absolute;
	left: 50%;
	bottom: 0;
	transform: translateX(-50%);
	content: "";
	display: block;
	width: 100%;
	height: 2px;
	/* background-color: #00316D; */
}
.checkbox-wrapper {
	display: flex;
	align-items: center;
	margin-right: 10px;
	cursor: pointer;
}
.checkbox-wrapper input[type="checkbox"] {
	display: none;
}
.checkbox-wrapper input[type="checkbox"] + label {
	cursor: pointer;
}
.checkbox-wrapper input[type="checkbox"] + label:before {
	content: '';
	display: inline-block;
	width: 14px;
	height: 14px;
	background: url(../../assets/popup/ico_uncheck_black.png) no-repeat center/cover;
}
.checkbox-wrapper input[type="checkbox"]:checked + label:before {
	background-image: url(../../assets/popup/ico_check_black.png);
}
.checkbox-text {
	display: flex;
	align-items: center;
	color: #fff;
	font-size: 12px;
	line-height: 14px;
	letter-spacing: -0.02em;
	margin-bottom: 0;
	gap: 4px;
}


.btn-area {
	background-color: #fff;
	width: 100%;
	display: flex;
	align-items: center;
}
.btn-wrap {
	width: 100%;
	text-align: center;
}
.btn-wrap:first-child button {
	border: 1px solid #ccc;
}
.btn-wrap button {
	border-color: #ccc;
	border-style: solid;
	border-width: 1px 1px 1px 0px;
}
.btn-wrap button:focus {
	box-shadow: none;
}

.btn-tab {
	background-color: #f3f3f3;
	border-radius: 0px;
	width: 100%;
	padding: 5px 0 11px;
}
.btn-tab span {
	color: #777;
	font-size: 10px;
	line-height: 12px;
	font-weight: 600;
	letter-spacing: -0.02em;
}
.btn-tab p {
	color: #777;
	font-size: 14px;
	line-height: 17px;
	font-weight: 600;
	letter-spacing: -0.02em;
}
.btn-tab.selected {
	background-color: #fff;
}
.btn-tab.selected span{
	color: #008def;
}
.btn-tab.selected p{
	color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciPopup.vue